import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		root: {
			height: '100vh',
			minWidth: 300,
			padding: '0 2rem',
			fontFamily: 'Poppins',
			[theme.breakpoints.down('xs')]: {
				padding: '0 .5rem !important', // Overrides inline-style
				margin: '-8rem 0 !important',
			},
		},
		bottomFooter: {
			bottom: 0,
			position: 'fixed',
			fontFamily: 'Poppins',
			[theme.breakpoints.down('xs')]: {
				background: 'white',
			},
		},
		welcomeImage: {
			fontFamily: 'Poppins',
			[theme.breakpoints.down('xs')]: {
				width: '366px', // Overrides inline-style
			},
		},
		welcomeTitle: {
			color: '#78393D',
			fontFamily: 'Poppins',
			padding: '1.5rem 0  0 !important',
			fontSize: '18px',
			[theme.breakpoints.down('xs')]: {
				padding: '1.5rem 0rem !important',
			},
		},
		welcomeMessage: {
			padding: '2rem 6rem',
			lineHeight: '2',
			fontFamily: 'Poppins',
			fontSize: '15px',
			color: 'rgba(168, 92, 97, 1)',
			[theme.breakpoints.down('xs')]: {
				padding: '0 1.2rem !important', // Overrides inline-style
				fontSize: '12px',
			},
		},
	});
});
